---
title: "Board Meeting - [DATE]"
date: "[YYYY-MM-DD]"
startTime: "[HH:MM]"
endTime: "[HH:MM]"
timezone: "America/Los_Angeles"
type: "Board Meeting"
status: "Draft"
attendees: [NUMBER]
summary: "[BRIEF_SUMMARY]"
published: false
---

<script lang="ts">
	export const metadata = {
		title: "Board Meeting - [DATE]",
		date: "[YYYY-MM-DD]",
		startTime: "[HH:MM]",
		endTime: "[HH:MM]",
		timezone: "America/Los_Angeles",
		type: "Board Meeting",
		status: "Draft",
		attendees: "[NUMBER]",
		summary: "[BRIEF_SUMMARY]",
		published: false
	};
</script>

# Board Meeting Minutes
## [FULL_DATE]

**Meeting Type:** Board of Directors Meeting  
**Date:** [FULL_DATE]  
**Time:** [START_TIME] - [END_TIME] MST  
**Location:** [MEETING_LOCATION]  
**Meeting Called to Order:** [START_TIME] by [PRESIDENT_NAME]  

### Attendance
**Board Members Present:** [LIST_BOARD_MEMBERS]  
**Officers Present:** [LIST_OFFICERS]  
**Guests/Members:** [GUEST_LIST]  

### Opening
- Call to order and establishment of quorum
- Approval of agenda

### Officer Reports

#### President's Report
[PRESIDENT_REPORT_CONTENT]

#### Vice President's Report
[VP_REPORT_CONTENT]

#### Secretary's Report
- Motion to approve [PREVIOUS_MEETING] board meeting minutes
- [MOTION_RESULT]

#### Treasurer's Report
- Current balance: $[AMOUNT]
- [DETAILED_FINANCIAL_REPORT]
- Motion to approve treasurer's report [MOTION_RESULT]

### Committee Reports
[COMMITTEE_REPORTS_AS_NEEDED]

### Old Business
1. **[ITEM_1_TITLE]**
   - [DISCUSSION_AND_STATUS]
   - [DECISIONS_MADE]

2. **[ITEM_2_TITLE]**
   - [DISCUSSION_AND_STATUS]
   - [DECISIONS_MADE]

### New Business
1. **[NEW_ITEM_1_TITLE]**
   - [DISCUSSION_DETAILS]
   - [BOARD_DECISION]
   - [VOTE_RESULT_IF_APPLICABLE]

2. **[NEW_ITEM_2_TITLE]**
   - [DISCUSSION_DETAILS]
   - [BOARD_DECISION]
   - [VOTE_RESULT_IF_APPLICABLE]

### Executive Session
*[IF_APPLICABLE - CONFIDENTIAL_MATTERS_DISCUSSED_IN_CLOSED_SESSION]*

### Action Items and Assignments
- [ ] [ASSIGNEE] [SPECIFIC_ACTION_ITEM] - Due: [DATE]
- [ ] [ASSIGNEE] [SPECIFIC_ACTION_ITEM] - Due: [DATE]

### Next Meeting
- **Date:** [NEXT_BOARD_MEETING_DATE]
- **Time:** [TIME]
- **Location:** [LOCATION]

### Adjournment
Motion to adjourn made by [NAME], seconded by [NAME]. Meeting adjourned at [END_TIME].

---

*Minutes prepared by: [SECRETARY_NAME_AND_CALL_SIGN]*  
*Minutes approved: [APPROVAL_DATE]*